import React, { forwardRef, useState } from "react";
import moment from "moment";

import Button from "components/CustomButtons/Button.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import Close from "@material-ui/icons/Close";

import { wsCreate } from "services/WService";
import { Toasty, useToasty } from "hooks/Toasty";
import { TextField } from "@material-ui/core";
import { Fragment } from "react";

const useStyles = makeStyles(styles);

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function ModalDailyCP(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const { show, close } = props;
  const customerPB = props.customerPB;
  function handleClose() {
    close(false);
    setDailyCPData({});
  }

  const [dailyCPData, setDailyCPData] = useState({});

  const handleChange = (e) => {
    setDailyCPData({
      ...dailyCPData,
      base_customer_portfolio_bureau_id: customerPB,
      [e.target.name]: e.target.value
    });
  };

  async function saveCustomerPD(data) {
    let response = await wsCreate("base/daily-customer-portfolio", data);
    if (response.success) {
      showNotify(response.message);
      handleClose();
    } else {
      showNotify(response.message, "error");
    }
  }

  return (
    <Fragment>
      <Toasty action={notify} />
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal
        }}
        open={show}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose()}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle disableTypography className={classes.modalHeader}>
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => handleClose()}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>Cartera diaria</h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody}>
          <TextField
            name="document_date"
            label="Fecha documento"
            type="date"
            defaultValue={moment().format("YYYY-MM-DD")}
            fullWidth
            onChange={handleChange}
            margin="normal"
          />
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <Button
            color="success"
            onClick={() => {
              saveCustomerPD(dailyCPData);
            }}
          >
            Guardar
          </Button>
          <Button onClick={() => handleClose()} color="danger">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
